"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HoneypotField = HoneypotField;
const jsx_runtime_1 = require("react/jsx-runtime");
/**
 * Hidden decoy field for the "website" honeypot in bot-protection.ts.
 * Real users never see or fill this in; bots that fill every field do,
 * which trips isHoneypotTripped() server-side.
 */
function HoneypotField({ value, onChange, name = "website", }) {
    return ((0, jsx_runtime_1.jsx)("input", { type: "text", name: name, value: value, onChange: (e) => onChange(e.target.value), tabIndex: -1, autoComplete: "off", "aria-hidden": "true", style: {
            position: "absolute",
            left: "-9999px",
            width: "1px",
            height: "1px",
            opacity: 0,
            pointerEvents: "none",
        } }));
}
